import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeSlug } from '../../../../utils';
import { addBodyStyleFilterAction, removeBodyStyleFilterAction } from '../../../../redux/actions/bodyStyleFilter';
import { getActiveBodyStyleFilterStatus } from '../../../../redux/selectors/bodyStyleFilter';

/**
 * Body Style Filter Item is a category of item, so all
 * Cars can be sorted into a car category, trucks into truck category, etc
 * and then filtered by the Filtering component.
 */
class BodyStyleFilterItem extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    addBodyStyleFilter: PropTypes.func.isRequired,
    removeBodyStyleFilter: PropTypes.func.isRequired,
    filterEnabled: PropTypes.bool,
  };

  static defaultProps = {
    filterEnabled: false,
  };

  constructor(props) {
    super(props);

    this.handleFilterItemChange = this.handleFilterItemChange.bind(this);
  }

  // Handles the changes in the user selected filter items
  handleFilterItemChange(event) {
    const { addBodyStyleFilter, removeBodyStyleFilter } = this.props;

    if (event.target.checked) {
      addBodyStyleFilter(event.target.value);
    } else {
      removeBodyStyleFilter(event.target.value);
    }
  }

  render() {
    const { title, id, filterEnabled } = this.props;
    const slug = makeSlug(id);

    return (
      <li>
        <label htmlFor={`filter-${slug}`}>
          <input className="filter-checkbox" value={`${slug}`} id={`filter-${slug}`} type="checkbox" checked={filterEnabled} onChange={this.handleFilterItemChange} />
          {title.toUpperCase()}
        </label>
      </li>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  filterEnabled: getActiveBodyStyleFilterStatus(state, makeSlug(ownProps.id))
});

const mapDispatchToProps = dispatch => ({
  addBodyStyleFilter: bindActionCreators(addBodyStyleFilterAction, dispatch),
  removeBodyStyleFilter: bindActionCreators(removeBodyStyleFilterAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BodyStyleFilterItem);



/** WEBPACK FOOTER **
 ** ./src/pages/ModelLineSelect/BodyStyleFilter/BodyStyleFilterItem/index.js
 **/